// Package imports:
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
// Component imports:
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import ListarSerpontunContactForm from '../ContactForms/ListarSerpontunContactForm/ListarSerpontunContactForm';
import Link from '../../ui-elements/Link/Link';

const ListarSerpontun: React.FC = () => {
    return (
        <div className="KCL_listar-serpontun">
            <div className="main__inner">
                <div className="shell">
                    <HeadSection
                        title="Sérpöntun á markhópalista"
                        description={<div>
                            <p>Afhending á sérpöntuðum markhópalista getur tekið 1-2 virka daga og er listinn afhentur sem Excel skjal. Verð miðast við 100 stærstu fyrirtækjalista og getur tekið breytingum eftir umfangi.</p>
                            <Link href='/Verdskra#verdskra' linkSize='16' targetBlank>
                                <FontAwesomeIcon icon={faAngleRight} />
                                Skoða verðskrá
                            </Link>
                        </div>}
                    />
                    <div className="section__body">
                        <div className="section__body-inner">
                            <div className="section__content form form--signup">
                                <ListarSerpontunContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListarSerpontun;
